<template>
    <!-- 校准信息tab  -->
    <div style="margin-left: 50px;">
      <el-form v-if="calibrationInfo">
        <el-form-item>
          <el-radio v-model="calibrationInfo.type" :label="1" disabled>{{ $t('device.start_calibration') }}</el-radio>
          <el-radio v-model="calibrationInfo.type" :label="0" disabled>{{ $t('device.no_calibration') }}</el-radio>
        </el-form-item>
        <template v-if="calibrationInfo.type">
        <!-- 校验到期时间 -->
        <el-form-item :label="$t('device.calibration_expiration')">
          <el-date-picker
            v-model="calibrationInfo.expireTime"
            type="date"
            :placeholder="$t('public.select_time')"
            disabled
            >
          </el-date-picker>
        </el-form-item>
        <!-- 校验通知 -->
        <el-form-item>
          <el-checkbox v-model="noticeChecked" disabled>{{ $t('device.calibration_notice') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          {{ $t('device.advance') }}
          <el-input v-model.trim="calibrationInfo.day" style="width: 70px" maxlength="5"
             disabled/>
          {{ $t('public.day') }},
          {{ $t('resource.in')}}
          <el-time-picker
            v-model="calibrationInfo.time"
            disabled
            style="width: 150px;"
            format="HH:mm"
            value-format="HH:mm"
          >
          </el-time-picker>
          {{ $t('device.notice') }}
        </el-form-item>
        <el-form-item v-if="calibrationInfo.objectList && calibrationInfo.objectList.length">
          <div v-for="(item, index) in calibrationInfo.objectList" :key="index" class="items">
            <el-tooltip class="item-icon" effect="dark" :content="item.phone" placement="top-start">
              <i
                class="el-icon-chat-dot-round"
                :style="{color: item.way.split('')[0] === '1' ? '#F59A23' : '#aaa'}">
              </i>
            </el-tooltip>
            <el-tooltip class="item-icon" effect="dark" :content="item.email" placement="top-start">
              <i
                class="el-icon-message"
                :style="{color: item.way.split('')[1]  === '1' ? '#F59A23' : '#aaa'}">
              </i>
            </el-tooltip>
            <!-- <el-tooltip class="item-icon" effect="dark" :content="item.phone" placement="top-start">
              <i
                class="el-icon-phone"
                :style="{color: item.way.split('')[2]  === '1' ? '#F59A23' : '#aaa'}">
              </i>
            </el-tooltip> -->
            <span class="item-name">{{ item.name }}</span>
          </div>
        </el-form-item>
        </template>
      </el-form>
    </div>

</template>

<script>
import { getCalibrationInfo } from '@/api/modules/sensor.js'
export default {
    props: ['detailData', 'calibrationInfo'],
    data() {
        return {
            QueryData: [],
            // calibrationInfo: {},
        }
    },
    computed: {
      noticeChecked(){
        if(this.calibrationInfo.objectList.length){
          return true
        }else{
          return false
        }
      }
    },
    methods: {
        getCalibration(){
        getCalibrationInfo(this.detailData.sensor.id).then(res => {
                if (res.state.code === 200) {
                    this.calibrationInfo = res.result
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.items {
  display: flex;
  margin-bottom: 8px;
  .item-icon {
    padding: 5px;
    border: 1px solid #CCCCCC;
    font-size: 18px;
  }
  .item-name {
    width: 360px;
    background-color: var(--primary-color);
    text-align: center;
    color: #FFFFFF;
  }
}

</style>
